<template>
  <v-layout @click="navigateToItem" class="cursor-pointer">
    <v-card width="150" min-width="125">
      <v-layout justify-center>
        <img class="mt-4 image-circle" :src="image" />
      </v-layout>

      <v-card-text>
        <v-layout justify-center row>
          <p class="mb-2 text-truncate text-xs-center">{{ name }}</p>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
export default {
  name: 'MenuCard',

  props: {
    name: {
      type: String,
      required: true
    },

    picture: {
      type: String,
      default: ''
    },

    url: {
      type: String,
      required: true
    }
  },

  computed: {
    image () {
      return this.picture || require('@/assets/images/placeholders/bear.svg')
    }
  },

  methods: {
    navigateToItem () {
      let isInternalUrl = false

      this.$router.options.routes.forEach(({ path }) => {
        if (this.url === path) isInternalUrl = true
      })

      if (isInternalUrl) {
        window.location = this.url
      } else {
        window.open(this.url, '_blank')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.cursor-pointer
  cursor pointer
</style>
